import Vue from "vue";
import Router from "vue-router";
import Base from "@/view/index/base.vue";



//BSD Project
import BSDMap from  "@/view/BSD/BSDMap"
import BSDMapEnv from  "@/view/BSD/BSDMapEnv"
import BSDMapRISK from  "@/view/BSD/BSDMapRISK"
import BSDMapPopulation from  "@/view/BSD/BSDMapPopulation"
import BSDMap_Login from  "@/view/BSD/Login"
import BNURegister from  "@/view/BSD/BNURegister"
import FindPassword from  "@/view/BSD/FindPassword"
import ResetPassword from  "@/view/BSD/ResetPassword"
import Feedback from  "@/view/BSD/Feedback"
import GuidePage from  "@/view/BSD/GuidePage"
import About from  "@/view/BSD/About"
import Main from "../view/BSD/Main";
import Introduction from "../view/BSD/About/Introduction";
import EditorialCommittee from "../view/BSD/About/EditorialCommittee"
import SupportingInstitutions from "../view/BSD/About/SupportingInstitutions"
import TableOfContents from "../view/BSD/About/TableOfContents"
import TemperatureChanges from "../view/BSD/About/TemperatureChanges"


import GDPDistribution from "../view/BSD/About/GDPDistribution"
import GDPExposureToDrought from  "../view/BSD/About/GDPExposureToDrought"
import GlobalCropExposureToExtremelyHighTemperature from  "../view/BSD/About/GlobalCropExposureToExtremelyHighTemperature"
import GlobalIndustrialValeAdded from "../view/BSD/About/GlobalIndustrialValeAdded"
import GlobalCropDistribution  from "../view/BSD/About/GlobalCropDistribution"
import GlobalRoadNetwork from "../view/BSD/About/GlobalRoadNetwork"
import GlobalClimateChangeRiskOfHeatwaveMortality from  "../view/BSD/About/GlobalClimateChangeRiskOfHeatwaveMortality"
import GlobalMortalityRiskToRiverFloods from  "../view/BSD/About/GlobalMortalityRiskToRiverFloods"
import GlobalClimateChangeRiskOfCropYield from "../view/BSD/About/GlobalClimateChangeRiskOfCropYield"
import RiceDistributionPrediction from "../view/BSD/About/RiceDistributionPrediction"
import GlobalGDPLossRiskToRiverFloods from  "../view/BSD/About/GlobalGDPLossRiskToRiverFloods"



import BNUCropsRisk from "../view/BSD/BNUCropsRisk";


Vue.use(Router);
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
export default new Router({
  routes: [
    { path: '/undefined',  redirect:"/cropsRisk", },
    { path: '/',  redirect:"/cropsRisk", },
    /**************************************************************************************************************
     * BNU Crops Risk
     */
    {
      path:"/cropsRisk",
      component:BNUCropsRisk,
      name: 'CropsRisk',
      meta: {
        title: '全国主要粮作物减产风险与保险费率地图'
      }
    }
  ],
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js